import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { xmlns: "http://www.w3.org/2000/svg" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 .75c.333 0 .64.176.809.464L11.87 9.84a.936.936 0 0 1-.808 1.411H.938a.94.94 0 0 1-.809-1.41l5.063-8.626A.94.94 0 0 1 6 .75m0 3a.56.56 0 0 0-.562.563v2.625a.561.561 0 1 0 1.125 0V4.313A.56.56 0 0 0 6 3.75M6.75 9a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
    }, null, -1)
  ])))
}
export default { render: render }